<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <side-bar :background-color="sidebarBackground">
      <template slot-scope="props" slot="links">
        <sidebar-item v-if="logged_user_role == 'Admin'"
            opened
            :link="{
            name: locale.work_shifts,
            icon: 'fa fa-clock-o',
            path: '/components/working-hours',
          }"
        >
          <sidebar-item
              :link="{
            name: locale.workers,
            // path: '/components/working-hours?workers',
            path: '/examples/user-management/list-users?reports',
          }"
          ></sidebar-item>
          <sidebar-item
              :link="{
            name: locale.projects,
            // path: '/components/working-hours?projects',
            path: '/components/projects?reports',
          }"
          ></sidebar-item>
          <sidebar-item
              :link="{
            name: locale.clients,
            // path: '/components/working-hours?clients',
            path: '/components/clients?reports',
          }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
            :link="{
            name: locale.dashboard,
            icon: 'now-ui-icons design_app',
            path: '/dashboard',
          }"
        >
        </sidebar-item>
        <sidebar-item
            :link="{
            name: locale.projects,
            icon: 'now-ui-icons ui-1_calendar-60',
            path: '/components/projects',
          }"
        ></sidebar-item>
        <sidebar-item v-if="logged_user_role == 'Admin'"
                      :link="{
            name: locale.clients,
            icon: 'now-ui-icons business_badge',
            path: '/components/clients',
          }"
        ></sidebar-item>
        <sidebar-item v-if="logged_user_role == 'Admin'"
                      :link="{
            name: locale.project_managers,
            icon: 'now-ui-icons business_badge',
            path: '/components/clientWorkers',
          }"
        ></sidebar-item>
        <sidebar-item v-if="logged_user_role == 'Admin'"
                      :link="{
            name: locale.workers,
            path: '/examples/user-management/list-users',
            icon: 'now-ui-icons users_single-02',
          }"
        ></sidebar-item>
        <sidebar-item v-if="logged_user_role == 'Worker'"
                      :link="{
            name: locale.Days_off,
            icon: 'now-ui-icons tech_watch-time',
            path: '/components/calendar',
          }"
        ></sidebar-item>

        <sidebar-item v-if="user_ag == null"
                      :link="{
            name: locale.companies,
            path: '/examples/company-management/list-companies',
            icon: 'now-ui-icons business_bank',
          }"
        ></sidebar-item>
        <user-menu></user-menu>
<!--        <sidebar-item v-if="logged_user_role == 'Admin'"-->
<!--                      :link="{-->
<!--            name: locale.areas,-->
<!--            icon: 'now-ui-icons location_map-big',-->
<!--          }"-->
<!--        >-->
<!--          <sidebar-item-->
<!--              :link="{ name: locale.countries, path: '/components/countries' }"-->
<!--          ></sidebar-item>-->
<!--          <sidebar-item-->
<!--              :link="{ name: locale.cities, path: '/components/cities' }"-->
<!--          ></sidebar-item>-->
<!--          <sidebar-item-->
<!--              :link="{ name: locale.postal_codes, path: '/components/postal-codes' }"-->
<!--          ></sidebar-item>-->

<!--        </sidebar-item>-->
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <sidebar-share
        :color.sync="sidebarBackground"
        :fixed-navbar.sync="fixedNavbar"
        :sidebarMini.sync="sidebarMini"
        style="cursor: pointer"
      >
      </sidebar-share>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { SlideYDownTransition, ZoomCenterTransition } from "vue2-transitions";
import Vuex from "vuex";
import SidebarShare from "./Extra/SidebarSharePlugin";

const url = process.env.VUE_APP_API_BASE_URL;

export default {
  components: {
    TopNavbar,
    ContentFooter,
    UserMenu,
    ZoomCenterTransition,
    SidebarShare,
  },
  data() {
    return {
      sidebarBackground: "black",
      fixedNavbar: false,
      sidebarMini: false,
      logged_user_role: '',
      locale: '',
      user_ag: '',
    };
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
        let text = this.$sidebar.isMinimized ? "activated" : "deactivated";
        this.$notify({ type: "info", message: `Sidebar mini ${text}...` });
      }
    },
  },
  mounted() {
    this.locale = this.$getLocale();

    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }
    // this.initScrollbar(), this.$store.dispatch("profile/me");
  },

  created() {
    // POST request using fetch with error handling
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json'
        , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
        , 'Accept': 'application/json'
      },
      body: JSON.stringify({ title: 'Vue POST Request Example' })
    };
    fetch(url + '/get-logged-role', requestOptions)
        .then(async response => {
          const data = await response.json();

          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || response.status;
            return Promise.reject(error);
          }

          this.logged_user_role = data[0].name;
          this.user_ag = data[0].ag;
        })
        .catch(error => {
          this.errorMessage = error;
          console.error('There was an error!', error);
        });
  },
  computed: {
    ...Vuex.mapState({
      me: (state) => state.profile.me,
    }),
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
